import BaseEntity from '@/core/misc/BaseEntity';
import Title_ru_RU from "@/core/misc/decorators/Title_ru_RU";
import TYPES from "@/core/services/Changelogs/types";
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

@Title_ru_RU_Class('Группа характеристик')          // characteristicGroup → CharacteristicGroup
export default class CharacteristicGroup extends BaseEntity {
	static Events = {
		Created: 'characteristicGroup:created',
		Updated: 'characteristicGroup:updated',
		Deleted: 'characteristicGroup:deleted',
	} as const;

	@Title_ru_RU('Название', TYPES.STRING)
	name: string;

	static fromServer(data: any, group: CharacteristicGroup = new CharacteristicGroup()): CharacteristicGroup {
		super.fromServer(data, group);

		return group;
	}
}
